module.exports = __webpack_public_path__ + "static/media/landing2.e5469cc8.png";